import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconOnaDownload: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M13.5 9.83337V13.5H2.5V9.83337" stroke="currentColor" strokeLinecap="square" />
                    <path
                        d="M5.66663 7.66663L7.99996 9.99996L10.3333 7.66663"
                        stroke="currentColor"
                        strokeLinecap="square"
                    />
                    <path d="M8 9.33333V2.5" stroke="currentColor" strokeLinecap="square" />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(2,2)">
                        <path d="M13.5 9.83337V13.5H2.5V9.83337" stroke="currentColor" strokeLinecap="square" />
                        <path
                            d="M5.66663 7.66663L7.99996 9.99996L10.3333 7.66663"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path d="M8 9.33333V2.5" stroke="currentColor" strokeLinecap="square" />
                    </g>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(4,4)">
                        <path d="M13.5 9.83337V13.5H2.5V9.83337" stroke="currentColor" strokeLinecap="square" />
                        <path
                            d="M5.66663 7.66663L7.99996 9.99996L10.3333 7.66663"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                        <path d="M8 9.33333V2.5" stroke="currentColor" strokeLinecap="square" />
                    </g>
                </svg>
            );
    }
};
